import DnProperties from './DnProperties.vue'

export default DnProperties
